import * as Sentry from '@sentry/react';

export const SENTRY_ORGANISATION = 'twine-net';
export const SENTRY_PROJECT_ID = 6118012;

const POLL_INTERVAL_MS = 500;
const MAX_ATTEMPTS = 41; // one immediate check, then every 500ms through 20s

// PostHog is loaded by Google Tag Manager, so window.posthog may not exist (or may still be the
// snippet stub without SentryIntegration) when Sentry initialises. Keep checking for a short
// while and attach PostHog's Sentry integration once the full library is available.
export const linkSentryToPostHog = () => {
  if (typeof window === 'undefined') {
    return;
  }

  let attempts = 0;

  const tryAttach = () => {
    const { posthog } = window;

    if (posthog && typeof posthog.SentryIntegration === 'function') {
      // Default severity allow list only forwards errors, not info-level messages
      Sentry.addIntegration(
        new posthog.SentryIntegration(
          posthog,
          SENTRY_ORGANISATION,
          SENTRY_PROJECT_ID
        )
      );
      return;
    }

    attempts += 1;
    if (attempts < MAX_ATTEMPTS) {
      setTimeout(tryAttach, POLL_INTERVAL_MS);
    }
  };

  tryAttach();
};
